import * as React from 'react'

import { CreateAlertLink } from './components/Navigation/CreateAlertLink'
import { NavigationLink } from './components/Navigation/QuoteLinkComponent'
import { QuoteLinksWrapper } from './components/Navigation/QuoteLinksWrapper'
import { SaveToPortfolioLink } from './components/Navigation/SaveToPortfolioLink'
import { QuotePortalContext } from './components/Portal'
import { QuoteQuery, QuoteSubview, QuoteView } from './types'

export function QuoteNavigation() {
  const { rootElement } = React.useContext(QuotePortalContext)
  const hasShortInterest = rootElement!.dataset.shortinterest === 'true'

  return (
    <React.Suspense fallback={null}>
      <QuoteLinksWrapper>
        <div className="flex space-x-0.5">
          <NavigationLink view={QuoteView.ChartDetail} removeQueryKeys={[QuoteQuery.Type]} additionalQueryValues={{}}>
            <span className="xl:hidden">Chart</span>
            <span className="hidden xl:inline">Stock Detail</span>
          </NavigationLink>
          <span className="text-muted-3">•</span>

          <NavigationLink
            isEliteOnly
            utmCampaign="quote-compare-perf"
            view={QuoteSubview.ComparePerf}
            data-testid="quote-compare-perf-link"
          >
            Compare Perf.
          </NavigationLink>
          <span className="text-muted-3">•</span>

          {hasShortInterest && (
            <>
              <NavigationLink view={QuoteSubview.ShortInterest}>Short Interest</NavigationLink>
              <span className="text-muted-3">•</span>
            </>
          )}

          <NavigationLink view={QuoteView.Financials}>Financials</NavigationLink>
          <span className="text-muted-3">•</span>

          {FinvizSettings.hasTrafficPageEnabled && (
            <>
              <NavigationLink view={QuoteSubview.Traffic}>Traffic</NavigationLink>
              <span className="text-muted-3">•</span>
            </>
          )}

          <NavigationLink view={QuoteView.Options} data-testid="options-chain-link">
            Options
          </NavigationLink>
          <span className="text-muted-3">•</span>

          <NavigationLink view={QuoteSubview.LatestFilings} data-testid="latest-filings-link">
            Latest Filings
          </NavigationLink>
          <span className="text-muted-3">•</span>

          <SaveToPortfolioLink />
          <span className="text-muted-3">•</span>

          <CreateAlertLink />
        </div>
      </QuoteLinksWrapper>
    </React.Suspense>
  )
}
